import React, { Component } from 'react';
import 'semantic-ui-css/semantic.min.css';
import './App.css';
import Container from './container/Container';

class App extends Component {
	render() {
		return <Container />;
	}
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js